<template>
  <div class="lista-unidades">
    <div class="row">
      <PublicHeader :title="remedio.principio_ativo || principio_ativo">
        <div class="col-xs-12 font-lg">
          <p v-if="remedio.portaria === '344/98'">
            Medicamento Controlado - Portaria 344/98
          </p>
          <p v-if="remedio.portaria === '471/2021'">
            Medicamento Antimicrobiano - RDC 471/2021
          </p>
        </div>
        <div class="col-xs-12 col-sm-6">
          <p class="subheader">
            Veja abaixo as unidades que possuem o medicamento pesquisado.
          </p>
        </div>
      </PublicHeader>
    </div>
    <div class="row">
      <div class="container">
        <Breadcrumb
          :links="[
            { label: 'Remédio Fácil', link: '/remedio-facil' },
            { label: remedio.principio_ativo || principio_ativo }
          ]"
        />
        <div class="row">
          <div class="col-xs-12 form-group" v-if="remedio.orientacao">
            <CriterioRemedio :remedio="remedio" />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <h3>Lista de unidades</h3>
          </div>
        </div>
        <div class="row" v-if="!carregando">
          <div class="col-xs-12">
            <OpenMap ref="mapa" :pins="pins" class="border-map" />
          </div>
        </div>
        <div class="row">
          <div v-if="carregando" class="col-xs-12 loading-unidades">
            <span>Carregando unidades</span>
            <font-awesome-icon :icon="'spinner'" size="2x" spin />
          </div>
          <div v-else class="lista">
            <div class="col-xs-12 form-group">
              <span class="label label-success">Disponível</span> - Estoque
              disponível
            </div>
            <div class="col-xs-12 form-group">
              <span class="label label-danger">Indisponível</span> - Estoque
              indisponível
            </div>
            <div class="col-xs-12">
              <p class="">
                <b>Observação:</b> A disponibilidade dos estoques está sujeita a
                variações. Pode conter diferença entre Sistema e estoque físico
                em períodos de 24h.
              </p>
            </div>
            <div
              class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
              v-for="unidade in unidades"
            >
              <router-link
                :to="{
                  name: 'detalhe-unidade',
                  params: {
                    detalhes: unidade.unidade_saude,
                    apelido: unidade.apelido,
                    unidade,
                    unidadesComRemedio: unidades,
                    remedio,
                    principio_ativo
                  }
                }"
              >
                <div class="card card-badge">
                  <span
                    v-if="isAvailable(unidade.saldo)"
                    class="label label-success"
                  >
                    Disponível
                  </span>
                  <span v-else class="label label-danger">
                    Indisponível
                  </span>
                  {{ unidade.apelido || unidade.unidade_saude }}
                </div>
              </router-link>
            </div>
          </div>
          <div
            v-if="!carregando && unidades.length == 0"
            class="col-xs-12 font-lg text-center"
          >
            <span>
              Nenhuma unidade encontrada para o medicamento
              {{ remedio.principio_ativo || principio_ativo }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PublicHeader,
  Breadcrumb,
  CriterioRemedio,
  OpenMap
} from '../../../components'
import { request } from '../../../request'
import { latLongGroup } from '../../../utils'

export default {
  components: { PublicHeader, Breadcrumb, CriterioRemedio, OpenMap },
  data() {
    return {
      carregando: false,
      remedio: {},
      principio_ativo: '',
      unidades: [],
      pins: []
    }
  },
  created() {
    const { remedio, principio } = this.$route.params

    if (!remedio && !principio) {
      this.$router.push('/aqui-tem-remedio')
      return
    }

    this.principio_ativo = remedio ? remedio.principio_ativo : principio
    this.remedio = remedio || {}

    this.getUnidadesRemedios()
  },
  updated() {
    if (this.$refs.mapa && this.pins.length) {
      this.$refs.mapa.fitPins()
    }
  },
  methods: {
    async getPosicaoMapa() {
      const nomesUnidades = this.unidades.map((unidade, index) => {
        return {
          unidade_saude: unidade.unidade_saude,
          disponivel: Number(unidade.saldo) > 0
        }
      })

      this.pins = await latLongGroup(nomesUnidades, this.$store)
    },
    toggleLoading() {
      this.carregando = !this.carregando
    },
    isAvailable(item) {
      const saldo = Number(item)
      return saldo > 0
    },
    async getUnidadesRemedios() {
      this.toggleLoading()

      try {
        if (!this.remedio.principio_ativo) {
          const { data } = await request.get('remedios/pesquisa', {
            params: { term: this.principio_ativo }
          })

          const finder = item => {
            return item.principio_ativo === this.principio_ativo
          }

          this.remedio = data.find(finder) || {}
        }

        const { data } = await request.get(`remedios/enderecos`, {
          params: { remedio_id: this.remedio.id_princ_ativo }
        })

        this.unidades = data
        this.getPosicaoMapa()
      } catch (error) {
        console.log(error)
        this.$toastr.e(
          'Houve um erro ao carregar as informações, tente novamente mais tarde.'
        )
      }

      this.toggleLoading()
    }
  }
}
</script>

<style scoped>
.card.card-badge {
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 5px;
}

span.label {
  padding: 5px;
  border-radius: 10px;
  display: inline-block;
  width: 90px;
}

.loading-unidades {
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-unidades > span {
  font-size: 2em;
  margin-right: 10px;
}

.border-map {
  border: 1px solid #468b35;
  margin-top: 15px;
  margin-bottom: 30px;
}

@media (min-width: 992px) {
  .card.card-badge {
    min-height: 115px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/public/remedios/Unidades.vue